import React from "react";
import { dashboard_cost, dental_cost } from "./../../assets/data/general";
import { gradient_primary, navy } from "../../assets/data/colors";

// the features
const dashboard_features = [
    "Lifetime access, no subscriptions",
    "All future updates — free",
    "30-day money-back guarantee",
    "Full data encryption",
    "Multi-session support"
];
const clinic_features = [
    "Custom domain and hosting",
    "Clinic gallery and cases",
    "Online appointment booking",
    "Blogs and social links",
    "Fully managed from dashboard"
]

const AboutPricing = () => {
    return (
        <div className="grid md:grid-cols-2 gap-6">
            <div style={{background: gradient_primary}} className="grad-bg rounded-3xl p-8 relative overflow-hidden">
                <div className="absolute top-0 right-0 w-48 h-48 rounded-full bg-[#378ADD] opacity-10 -translate-y-1/2 translate-x-1/2" />
                <p style={{color: navy}} className="text-xs font-semibold tracking-[3px] uppercase mb-2">Dashboard</p>
                <div className="flex items-baseline gap-1 mb-1">
                    <span className="text-5xl font-bold text-white">${dashboard_cost}</span>
                    <span className="text-white/50 text-sm">one-time</span>
                </div>
                <p className="text-white/60 text-sm mb-8">Pay once. Yours forever.</p>

                <div className="space-y-3">
                    {dashboard_features.map((item, i) => (
                        <div key={i} className="flex items-center gap-3">
                            <div className="w-5 h-5 rounded-full bg-[#378ADD]/30 border border-[#378ADD]/50 flex items-center justify-center flex-shrink-0">
                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                                    <path
                                        d="M2 6l3 3 5-5"
                                        stroke="#85B7EB"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <span className="text-white/80 text-sm">{item}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="bg-white dark:bg-[#0d1117] border border-gray-100 dark:border-gray-800 rounded-3xl p-8 relative overflow-hidden flex flex-col">
                <p style={{color: navy}} className="text-xs font-semibold tracking-[3px] uppercase mb-2">Dental Site</p>
                <div className="flex items-baseline gap-1 mb-1">
                    <span className="text-5xl font-bold grad-text dark:text-white">${dental_cost}</span>
                    <span className="text-gray-400 text-sm">additional</span>
                </div>
                <p className="text-gray-400 text-sm mb-8">Your clinic's public face, built and hosted for you.</p>
                <div className="space-y-3 flex-1">
                    {clinic_features.map((item, i) => (
                        <div key={i} className="flex items-center gap-3">
                            <div className="w-5 h-5 rounded-full bg-[#E6F1FB] dark:bg-[#0C447C]/30 border border-[#B5D4F4] dark:border-[#185FA5] flex items-center justify-center flex-shrink-0">
                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                                    <path
                                        d="M2 6l3 3 5-5"
                                        stroke="#378ADD"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                            <span className="text-gray-600 dark:text-gray-300 text-sm">{item}</span>
                        </div>
                    ))}
                </div>

                <div className="mt-8 pt-6 border-t border-gray-100 dark:border-gray-800">
                    <p className="text-xs text-gray-400 text-center">
                        The dashboard is{" "}
                        <span className="font-semibold text-gray-600 dark:text-gray-200">required</span>. The dental site is{" "}
                        <span className="font-semibold text-gray-600 dark:text-gray-200">optional</span>.
                    </p>
                </div>
            </div>

            <div className="md:col-span-2 bg-gradient-to-r from-[#E6F1FB] to-[#f0f7ff] dark:from-[#042C53]/40 dark:to-[#0C447C]/20 border border-[#B5D4F4] dark:border-[#185FA5]/30 rounded-2xl p-6 flex items-center gap-4">
                <div>
                    <h4 className="font-semibold text-[#042C53] dark:text-[#85B7EB] mb-1">30 Days Money-Back Guarantee</h4>
                    <p className="text-sm text-[#185FA5] dark:text-[#B5D4F4]/70 font-light">Not satisfied within 30 days? Get a full refund — no questions asked.</p>
                </div>
            </div>

        </div>
    );
};
export default AboutPricing;